module.exports = __webpack_public_path__ + "static/img/OOSH_026.b60e17a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_026.jpg
// module id = kg4s
// module chunks = 170